module.exports = __webpack_public_path__ + "img/selected5-min.5afc1e78.png";